export const CHANGE_DEBOUNCE_VAL = 1500;
export const LOCAL_STORAGE_NS = 'pdf-creator';
